import { Component, Vue } from "vue-property-decorator";
import { ItiString, itiTokenService } from '@/iti-core-vue';


@Component({
    components: {

    }
})

export default class OffersDemandForm extends Vue {

    private get urlInsylay(){
        return ItiString.Format(process.env.VUE_APP_INSYLAY_REGISTRY, itiTokenService.getToken());
    }
}